import { DailyWorkRepository, DailyWorkDayJoin, type DayWithClockRecords } from "@/repositories/daily-work.repository";

export async function acceptDailyWorkDay(dayId: string): Promise<DailyWorkDayJoin> {
  return DailyWorkRepository.acceptDay(dayId);
}

export async function listDailyWorkDaysForIndividual(
  page: number,
  pageSize: number,
  filters: {
    startDate?: string;
    endDate?: string;
    search?: string;
    status?: string;
  },
  sortKey: string,
  sortOrder: "asc" | "desc"
) {
  return DailyWorkRepository.listDaysForIndividual(page, pageSize, filters, sortKey, sortOrder);
}

export async function getDailyWorkDayWithClockRecords(dayId: string): Promise<DayWithClockRecords> {
  return DailyWorkRepository.getDayWithClockRecords(dayId);
}

export async function goOnSite(dayId: string): Promise<DayWithClockRecords> {
  return DailyWorkRepository.goOnSite(dayId);
}

export async function goOffSite(dayId: string, notes: string): Promise<DayWithClockRecords> {
  return DailyWorkRepository.goOffSite(dayId, notes);
}

export async function tickClockRecordTask(dayId: string, position: number, done: boolean): Promise<DayWithClockRecords> {
  return DailyWorkRepository.tickTask(dayId, position, done);
}

export async function writeClockRecordNotes(dayId: string, notes: string): Promise<DayWithClockRecords> {
  return DailyWorkRepository.writeNotes(dayId, notes);
}
